module.exports = __webpack_public_path__ + "static/media/icLikes.ee46d5b0.svg";